import React, { useState, useEffect } from 'react';
import { useGlobal, setGlobal } from 'reactn';
import { Redirect, Link } from 'react-router-dom';

import Card from '../common/card/Card';

import api from '../../api';

const ForgotPasswordEmailVerification = ({ match }) => {
  useEffect(() => {
    verifyToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

      const verifyToken = async () => {
        setGlobal({ forgotPasswordToken: match.params.token });
      // await api.forgotPasswordEmailVerification(match.params.token);
      };
  return (
    <div>
      <Card
        backgroundClass="bg-white text-center"
        title="MCWA Customer Portal Signup Confirmation"
      >
        <h1>Email Verification Successul!</h1>
        <p>Continue to change your password.</p>
        <Link to="/auth/edit-credentials">Change Password &rsaquo;</Link>
      </Card>
      {/* <Redirect to="/auth/edit-credentials" /> */}
    </div>
  );
};

export default ForgotPasswordEmailVerification;
